// extracted by mini-css-extract-plugin
export default {"avi-mobile__title":"avi-mobile__title_p_0GSGlt","avi-mobile__address":"avi-mobile__address_WwfE5Abh","avi-mobile__inline-notification":"avi-mobile__inline-notification_TFp6QoHv"};